export { fixStripes, isScrolledIntoView, toFixedNumber };

const fixStripes = function(all, odd, even) {
	$(all).removeClass("odd");
	$(all).removeClass("even");
	$(odd).addClass("even");
	$(even).addClass("odd");
}

const isScrolledIntoView = function(elem) {
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height();

	var elemTop = $(elem).offset().top;
	var elemBottom = elemTop + $(elem).height();

	return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));

}

const toFixedNumber = function(num, precision) {
	return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
}